import { createSlice } from '@reduxjs/toolkit';

//const token = storage.get("classToken") || "";

const initialState = {
  updateClassInfo: [
    {
      courseNumber: '',
      courseName: '',
      startDate: '',
      endDate: '',
      schedule: '',
    },
  ],
};

const slice = createSlice({
  name: 'classinfo',
  initialState,

  reducers: {
    setUpdateClass: (state, action) => {
      state.updateClassInfo = action.payload;
    },
    resetClass: (state) => {
      state = initialState;
    },
  },
});

export const { setUpdateClass, resetClass } = slice.actions;
export default slice.reducer;
